/**
 * @typedef { import('../../../time.js').YearMonthPeriod } YearMonthPeriod
 * @typedef { import('../../../time.js').YearMonth } YearMonth
 */

export class Report {
  /**
   * @param {YearMonthPeriod} period
   * @param {?Map<string, Cohort>} cohorts
   */
   constructor(period, cohorts) {
    this._period = period;
    this._cohorts = cohorts;
  }

  getPeriod() {
    return this._period;
  }

  /**
   * @param {YearMonth} yearMonth 
   * @returns {Object}
   */
  getCohort(yearMonth) {
    const cohort = this._findCohort(yearMonth);
    if(cohort === null) {
      return new NullCohort(yearMonth);
    }

    return cohort;
  }

  /**
   * @param {YearMonth} yearMonth 
   * @returns {?Cohort}
   */
  _findCohort(yearMonth) {
    if(this._cohorts === null) {
      return null;
    }

    const yearMonthStr = yearMonth.toString()
    const cohort = this._cohorts.get(yearMonthStr);
    if(cohort === undefined) {
      return null;
    }

    return cohort;
  }
}


export class Cohort {
  /**
   * @param {YearMonth} yearMonth 
   * @param {number} size 
   * @param {Map<string, number>} metrics
   */
  constructor(yearMonth, size, metrics) {
    /** @type {YearMonth} */
    this._yearMonth = yearMonth;

    /** @type {number} */
    this._size = size;

    /** @type {Map<string, number>} */
    this._metrics = metrics;
  }

  getName() {
    return getCohortName(this._yearMonth);
  }

  getSize() {
    return this._size;
  }

  /**
   * @param {YearMonth} yearMonth
   * @returns {number}
   */
  getMetric(yearMonth) {
    const yearMonthStr = yearMonth.toString();

    const value = this._metrics.get(yearMonthStr);
    if(value === undefined) {
      return 0;
    }
    return value;
  }
}

  
class NullCohort {
  /** @param {YearMonth} yearMonth */
  constructor(yearMonth) {
    /** @type {YearMonth} */
    this._yearMonth = yearMonth;
  }

  getName() {
    return getCohortName(this._yearMonth);
  }

  getSize() {
    return 0;
  }

  getMetric() {
    return 0;
  }
}

/**
 * @param {YearMonth} yearMonth 
 * @returns {string}
 */
function getCohortName(yearMonth) {
   return yearMonth.toString();
}
